<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Historial de sesiones eliminadas</h3>
  </div>
  <hr />
  <table class="table table-striped">
    <thead>
      <tr>
        <th class="col">Cliente</th>
        <th class="col">Colaborador</th>
        <th class="col">Total de sesiones</th>
        <th class="col">Sesion eliminada</th>
        <th class="col">Precio del paquete</th>
        <th class="col">Fecha de eliminacion</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let delete of dataHistory">
        <td>{{ delete.client.name }}</td>
        <td>{{ delete.employee.name }}</td>
        <td>{{ delete.appt.total_sessions }}</td>
        <td>{{ delete.session_number }}</td>
        <td>{{ delete.package.subtotal }}</td>
        <td>{{ delete.createdAt }}</td>
      </tr>
    </tbody>
  </table>
</div>
